<template>
  <div v-editable="blok" class="constrain py-8 lg:py-24 relative z-30">
    <div class="text-center max-w-3xl m-auto">
      <h2 class="heading-2 pb-6">{{ blok.title }}</h2>
      <p class="text-grey-dark">{{ blok.subtitle }}</p>
    </div>
    <!-- Steps Grid -->
    <div :class="`
      grid grid-cols-1
      gap-4
      lg:gap-12
      mt-4
      lg:mt-16
      grid-cols-${blok.columns_base || 1}
      sm:grid-cols-${blok.columns_sm || 2}
      md:grid-cols-${blok.columns_md || 2}
      lg:grid-cols-${blok.columns_lg || 4}
      xl:grid-cols-${blok.columns_xl || 4}
      `"
    >
      <div
        v-for="(usp, index) in blok.usps"
        :key="index"
        class="text-center border border-grey-2 rounded-2xl p-6 bg-white flex flex-col items-center justify-start space-y-4"
      >
        <!-- Step icon -->
        <div class="w-[49px] h-[49px] flex-shrink-0 flex justify-center items-center text-primary bg-[#DCFBEA] rounded-lg text-center font-bold text-[1.3125rem]">
          <NuxtImg
            provider="storyblok"
            :src="usp.icon.filename"
            :alt="getImageAlt(usp.icon)"
            loading="lazy"
            format="webp"
            width="32px"
            height="32px"
          />
        </div>

        <div class="flex flex-col items-center">
          <!-- Step Title -->
          <h5 class="subtitle-4 text-center">{{ usp.name }}</h5>

          <!-- Step Description -->
          <p class="text-grey-dark text-md font-normal text-center mt-4">{{ usp.body }}</p>
        </div>
      </div>
    </div>

    <Gradients :gradients="blok.gradients" />
  </div>
</template>

<script setup>
defineProps({ blok: Object });
const { getImageAlt } = useImageAlt();
</script>
